import React from "react";
import client from "@culturehq/client";

import { useFetch, useFieldsLabels } from "app/hooks";
import { t } from "app/utils";

import SelectTags from "components/post/SelectTags";

const StoryFilterBar = ({
  creatable = false,
  selectedOptions,
  handleClearSelectedOptions,
  handleSelectedTags,
  icon = undefined,
  creatableLabel = "Search story text for",
  newOptions
}) => {
  const labels = useFieldsLabels();
  const { _fetching, json: { storyQuestions } } = useFetch(
    () => client.getStoryQuestions({ all: 1 }),
    []
  );

  return (
    <SelectTags
      allWordsMatch
      ariaLabel={t(`Filter stories by tag, ${labels.departments.singular.toLowerCase()}, location and/or user`)}
      creatable={creatable}
      creatableLabel={t(creatableLabel)}
      icon={icon}
      isSearchBar
      onClearSelectedOptions={handleClearSelectedOptions}
      onShareWithChanged={handleSelectedTags}
      placeholder={t(`Filter stories by tag, ${labels.departments.singular.toLowerCase()}, location and/or user`)}
      selectedOptions={selectedOptions}
      storyQuestions={storyQuestions}
      withOrgValues
      withUsers
      newOptions={newOptions}
    />
  );
};

export default props => (
  <div className="EmbedStories StoriesFilterBar">
    <StoryFilterBar {...props} />
  </div>
);
